export const VOICE_LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN', recognition: 'en-IN', synthesis: 'en-IN' },
  { code: 'kn', label: 'ಕನ್ನಡ', short: 'KN', recognition: 'kn-IN', synthesis: 'kn-IN' },
  { code: 'hi', label: 'हिंदी', short: 'HI', recognition: 'hi-IN', synthesis: 'hi-IN' },
];

export const VOICE_LANG_STORAGE_KEY = 'ubsaapp_voice_language';

export const getStoredVoiceLanguage = () => {
  try {
    const stored = localStorage.getItem(VOICE_LANG_STORAGE_KEY);
    if (stored && VOICE_LANGUAGES.some((l) => l.code === stored)) return stored;
  } catch {
    /* ignore */
  }
  return 'en';
};

export const setStoredVoiceLanguage = (code) => {
  try {
    localStorage.setItem(VOICE_LANG_STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
};

export const getSpeechRecognitionLang = (code) =>
  VOICE_LANGUAGES.find((l) => l.code === code)?.recognition || 'en-IN';

export const getSpeechSynthesisLang = (code) =>
  VOICE_LANGUAGES.find((l) => l.code === code)?.synthesis || 'en-IN';

export const VOICE_NOT_SUPPORTED_MSG = {
  en: 'Voice is not supported in this browser. Please use Chrome or Edge.',
  kn: 'ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ವಾಯ್ಸ್ ಬೆಂಬಲವಿಲ್ಲ. Chrome ಅಥವಾ Edge ಬಳಸಿ.',
  hi: 'इस ब्राउज़र में वॉयस समर्थित नहीं है। Chrome या Edge का उपयोग करें।',
};

export const VOICE_LISTENING_HINT = {
  en: 'Listening… speak your search or booking request',
  kn: 'ಕೇಳುತ್ತಿದ್ದೇನೆ… ನಿಮ್ಮ ಹುಡುಕಾಟ ಅಥವಾ ಬುಕಿಂಗ್ ವಿನಂತಿಯನ್ನು ಹೇಳಿ',
  hi: 'सुन रहा हूँ… अपनी खोज या बुकिंग बताएं',
};
